export default {
  'summarizing-deductive': {
    'course-title': 'Deductive Reasoning',
    'course-name': 'Section 3A-2 <span class="unit-title">Deductive Reasoning<span>',
    'unit-section-title': '3A-2 Exercises',
    'exercise-title': 'Summarizing a Deductive Argument',
    'exercise-description-1': 'Deductive summaries should try to encompass all the parts of the deductive argument, not just repeat the “therefore” point. Because the resulting summary statement often serves as a base from which to develop the thinking further, either inductively or deductively, you want it to be as solid as possible, and also as interesting.',
    'exercise-description-2': `<p>The technique for summarizing a deductive argument demands some creative thinking. You need to:</p>
        <ul>
          <li>Read the argument</li>
          <li>State the bare bones of the final point in the box above (I have given you the opening words)</li>
          <li>Add to it the essence of the first two points (often by thinking “because”)</li>
          <li>Rewrite to turn it into a pithier, more graceful statement</li>
          <li>Press REVEAL and compare your answers</li>
        </ul>
        <p>The wordings you generate in the exercises that follow may differ from mine, but - so long as they say roughly the same thing – it does not mean they are wrong.</p>`,
    'exercise-description-3': `<p>I have put together a few examples on which you can practice summarizing deductive arguments. To help you focus, I have underlined the important words in each box on the key line and I have given you the first few words in the "bare bones” rough summary box, complete this and fill in the simplified summary box above. Your answers may not match mine exactly, but you should get the gist. When you are happy with your answers click the “Reveal" button to show the school solution.
    </p>`,
    'menu-list': {
      'exercise-1': 'Digitization',
      'exercise-2': 'Paying Taxes',
      'exercise-3': 'Habits',
      'exercise-4': 'Music for Students',
      'exercise-5': 'Monetary Policy',
    },
    'exercise-1-number': '3A-2 - Exercise 1',
    'exercise-1-title': 'Digitization',
    'exercise-2-number': '3A-2 - Exercise 2',
    'exercise-2-title': 'Paying Taxes',
    'exercise-3-number': '3A-2 - Exercise 3',
    'exercise-3-title': 'Habits',
    'exercise-4-number': '3A-2 - Exercise 4',
    'exercise-4-title': 'Music for Students',
    'exercise-5-number': '3A-2 - Exercise 5',
    'exercise-5-title': 'Monetary Policy',
    'congratulation-message': 'THANK YOU',
    'finish-section': 'You have completed Section 3A-2',
    'final-description': 'You now know how to draw a graceful and useful insight from a deductive argument',
    'next-course-button': 'proceed to section 3A-3',
    'dashboard-button': 'Main menu',
  }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a2/summarizingDeductive/i18n/en.js